import { PureComponent } from 'react'
import styles from './index.css'
import { FormValueSelector } from '../../../Common/forms'
import { ProposalBlock } from '@vzmi/shp_shared_compo'
import ProposalInfo from '../../Common/ProposalForm/ProposalInfo/ProposalInfo'
import ProductInfoContainer from '../../Common/ProposalForm/ProductInfo/ProductInfoContainer'

export class Info extends PureComponent {
  triggerFieldChange = (...props) => {
    const { change } = this.props
    return change(...props)
  }

  render () {
    const {
      className,
      subStationOptions,
      user,
      match,
      proposalType,
      reduxFormState,
      flags,
      fromClone,
      change
    } = this.props
    const isNewProposal = !fromClone
    return (
      <div
        className={`${styles.Basic} ${className}`}
        data-role='compose-basic'
      >
        <FormValueSelector
          selector={select => ({
            mustShowFormError: select('mustShowFormError')
          })}
        >
          {({ mustShowFormError }) => (
            <>
              <ProposalBlock>
                <ProposalInfo
                  subStationOptions={subStationOptions}
                  isNewProposal={isNewProposal}
                  mustShowFormError={mustShowFormError}
                  change={change}
                  user={user}
                  flags={flags}
                />
              </ProposalBlock>
              <ProposalBlock>
                <ProductInfoContainer
                  user={user}
                  triggerFieldChange={this.triggerFieldChange}
                  formState={reduxFormState}
                  match={match}
                  proposalType={proposalType}
                  flags={flags}
                  isNewProposal={isNewProposal}
                  mustShowFormError={mustShowFormError}
                />
              </ProposalBlock>
            </>
          )}
        </FormValueSelector>
      </div>
    )
  }
}

export default Info
